<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-warning">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <b-row align-v="center" slot="header">
                <b-col cols="4"> </b-col>
                <b-col cols="8" class="text-right">
                  <router-link
                    to="categoria-peca-profissional-independente/novo"
                    class="btn btn-primary"
                  >
                    Novo
                  </router-link>
                </b-col>
              </b-row>
            </b-card-header>

            <el-table
              class="table-responsive table"
              header-row-class-name="thead-light"
              :data="data"
              v-loading="loading"
              empty-text="Não há dados para mostrar"
            >
              <el-table-column label="Nome" prop="nome" min-width="120px">
              </el-table-column>
              <el-table-column label="Senha" prop="senha" min-width="140px">
              </el-table-column>
              <el-table-column label="Posição" prop="posicao" min-width="140px">
              </el-table-column>
              <el-table-column label="Ativo" prop="ativo" min-width="80px">
                <template v-slot="{ row }">
                  {{ row.ativo ? "Sim" : "Não" }}
                </template>
              </el-table-column>

              <el-table-column label="Ações" prop="id" min-width="80px">
                <template v-slot="{ row }">
                  <div class="d-flex align-items-center">
                    <router-link
                      :to="'categoria-peca-profissional-independente/' + row.id"
                      class="btn btn-sm btn-primary"
                    >
                      Editar
                    </router-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
              <base-pagination
                v-model="pagination.page"
                :per-page="pagination.size"
                :total="pagination.totalElements"
                v-on:change="load"
              ></base-pagination>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
      <div class="mt-5"></div>
    </b-container>
  </div>
</template>
<script>
import api from "@/services/api";
import { Table, TableColumn } from "element-ui";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      data: [],
      loading: false,
      pagination: {
        page: 0,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    };
  },
  methods: {
    async load(page = 1) {
      this.loading = true;
      try {
        const response = await api.get(
          `/categoria-peca-profissional-independente?size=10&page=${page - 1}`
        );
        this.data = response.data.data;
        this.pagination = response.data.pagination;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.load();
  },
};
</script>
